var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoutIcon = function SvgLogoutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M5.25 2.333a.833.833 0 0 0 0-1.667H4A3.333 3.333 0 0 0 .667 3.999v10A3.333 3.333 0 0 0 4 17.333h1.25a.833.833 0 0 0 0-1.667H4c-.92 0-1.666-.746-1.666-1.667V4c0-.92.746-1.666 1.666-1.666z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.923 9.589a.833.833 0 0 0 0-1.179L14.59 5.077a.833.833 0 1 0-1.179 1.178l1.91 1.911H5.668a.833.833 0 1 0 0 1.667h9.655l-1.91 1.91a.833.833 0 1 0 1.178 1.179z"
  })));
};
export default SvgLogoutIcon;